import { render, staticRenderFns } from "./CreatorRequestSent.vue?vue&type=template&id=01dc1266&"
import script from "./CreatorRequestSent.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports